module.exports = __webpack_public_path__ + "static/media/homepage-hero-background.7c6ced79.svg";